import axios from 'axios';

const driversService = {
    getDrivers,
    getDriverById,
    addDriver,
    editDriver,
    deleteDriver,
    editPermissions
}

async function getDrivers() {
    return await axios.get('/Drivers')
}

async function getDriverById(id) {
    return await axios.get(`/Drivers/${id}`)
}

async function addDriver(driverDetails) {
    return await axios.post('/Drivers', driverDetails)
}

async function editDriver(driverDetails) {
    return await axios.put(`/Drivers/${driverDetails.driverId}`, driverDetails)
}

async function deleteDriver(id) {
    return await axios.delete('/Drivers/DeleteDriver/'+id)
}

async function editPermissions(permissions) {
    return await axios.post(`/Drivers/EditPermissions`, permissions)
}

export default driversService;